import { render, staticRenderFns } from "./users.vue?vue&type=template&id=2b47c116&scoped=true&"
import script from "./users.vue?vue&type=script&lang=js&"
export * from "./users.vue?vue&type=script&lang=js&"
import style0 from "./users.vue?vue&type=style&index=0&id=2b47c116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47c116",
  null
  
)

export default component.exports